<template>
  <form autocomplete="off" v-on:submit.prevent="onSubmit">
    <alert v-show="showAlert"
      alertClass="m-b-25 alert-dismissible"
      type="danger"
      iconClass="wb-close">
      <span>{{errorResponse}}</span>
    </alert>
    <div class="row">
      <form-group formGroupClass="col-xs-12 col-md-6" v-bind:error="formErrors.first('first_name')">
        <label class="form-control-label">{{ $t("billing.information.labels.firstname") }}</label>
        <input type="text" class="form-control" autocomplete="off" v-model="newBillingInformation.first_name">
      </form-group>
      <form-group formGroupClass="col-xs-12 col-md-6" v-bind:error="formErrors.first('last_name')">
        <label class="form-control-label">{{ $t("billing.information.labels.lastname") }}</label>
        <input type="text" class="form-control" autocomplete="off" v-model="newBillingInformation.last_name">
      </form-group>
    </div>
    <div class="row">
      <form-group formGroupClass="col-md-12" v-bind:error="formErrors.first('company_name')">
        <label class="form-control-label">{{ $t("billing.information.labels.companyName") }}</label>
        <input type="text" class="form-control" autocomplete="off" v-model="newBillingInformation.company_name">
      </form-group>
    </div>
    <div class="row">
      <form-group formGroupClass="col-md-12" v-bind:error="formErrors.first('tax_id')">
        <label class="form-control-label">{{ $t("billing.information.labels.taxID") }}</label>
        <input type="text" class="form-control" autocomplete="off" maxlength="13" v-model="newBillingInformation.tax_id">
      </form-group>
    </div>
    <div class="row">
      <form-group formGroupClass="col-md-12" v-bind:error="formErrors.first('address1')">
        <label class="form-control-label">{{ $t("billing.information.labels.addressLine1") }}</label>
        <input type="text" class="form-control" autocomplete="off" v-model="newBillingInformation.address1">
      </form-group>
    </div>
    <div class="row">
      <form-group formGroupClass="col-md-12" v-bind:error="formErrors.first('address2')">
        <label class="form-control-label">{{ $t("billing.information.labels.addressLine2") }}<small class="required grey-500">( Optional )</small></label>
        <input type="text" class="form-control" autocomplete="off" v-model="newBillingInformation.address2">
      </form-group>
    </div>
    <div class="row">
      <form-group formGroupClass="col-xs-12 col-md-6" v-bind:error="formErrors.first('city')">
        <label class="form-control-label">{{ $t("billing.information.labels.city") }}</label>
        <input type="text" class="form-control" autocomplete="off" v-model="newBillingInformation.city">
      </form-group>
      <form-group formGroupClass="col-xs-12 col-md-6" v-bind:error="formErrors.first('state')">
        <label class="form-control-label">{{ $t("billing.information.labels.state") }}</label>
        <input type="text" class="form-control" autocomplete="off" v-model="newBillingInformation.state">
      </form-group>
    </div>
    <div class="row">
      <form-group formGroupClass="col-xs-12 col-md-6" v-bind:error="formErrors.first('zipcode')">
        <label class="form-control-label">{{ $t("billing.information.labels.zipCode") }}</label>
        <input type="text" class="form-control" autocomplete="off" v-model="newBillingInformation.zipcode">
      </form-group>
      <form-group formGroupClass="col-xs-12 col-md-6" v-bind:error="formErrors.first('country')">
        <label class="form-control-label">{{ $t("billing.information.labels.country") }}</label>
        <select class="form-control" v-model="newBillingInformation.country">
          <option value="TH">Thailand</option>
        </select>
      </form-group>
    </div>
    <div class="row">
      <form-group formGroupClass="col-xs-12 col-md-6" v-bind:error="formErrors.first('contact_phone')">
        <label class="form-control-label">{{ $t("billing.information.labels.billingContactPhone") }}</label>
        <input type="tel" class="form-control" autocomplete="off" v-model="newBillingInformation.contact_phone">
      </form-group>
      <form-group formGroupClass="col-xs-12 col-md-6" v-bind:error="formErrors.first('contact_email')">
        <label class="form-control-label">{{ $t("billing.information.labels.billingEmail") }}</label>
        <input type="email" class="form-control" autocomplete="off" v-model="newBillingInformation.contact_email" >
      </form-group>
    </div>
    <div class="row">
      <div class="col-md-12 col-xs-12" style="text-align: right;">
        <loading-button
          v-bind:isSubmiting="isSubmiting"
          class="text-capitalize m-r-10">
          {{ $t("billing.information.action.saveDetails") }}
        </loading-button>
        <button type="button" class="btn btn-default text-capitalize" v-on:click="onCancelButtonClick">
          Cancel
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import axios from 'axios';
import { Validator } from 'vee-validate';
import Alert from 'components/Alert';
import FormGroup from 'components/forms/FormGroup';
import LoadingButton from 'components/LoadingButton';

export default {
  components: {
    Alert,
    FormGroup,
    LoadingButton,
  },
  props: {
    team: {
      type: Object,
    },
    billingInformation: {
      type: Object,
    },
  },
  watch: {
    billingInformation: function(value) {
      this.newBillingInformation = Object.assign({}, value);
    },
    'newBillingInformation.company_name': function(value) {
      if (value) {
        this.isRequiredTaxIDField = true;
      } else {
        this.isRequiredTaxIDField = false;
      }
    },
  },
  data: function() {
    return {
      isSubmiting: false,
      isRequiredTaxIDField: false,
      showAlert: false,
      validator: null,
      formErrors: null,
      errorResponse: null,
      successResponse: null,
      newBillingInformation: {
        first_name: null,
        last_name: null,
        company_name: null,
        tax_id: null,
        address1: null,
        address2: null,
        city: null,
        state: null,
        zipcode: null,
        country: 'TH',
        contact_phone: null,
        contact_email: null,
      },
    };
  },
  created: function() {
    this.validator = new Validator();
    this.validator.attach('first_name', 'required', { prettyName: 'First Name' });
    this.validator.attach('last_name', 'required', { prettyName: 'Last Name' });
    this.validator.attach('address1', 'required', { prettyName: 'Address Line 1' });
    this.validator.attach('city', 'required', { prettyName: 'City / Town' });
    this.validator.attach('state', 'required', { prettyName: 'State / Province / Region' });
    this.validator.attach('zipcode', 'required', { prettyName: 'ZIP Code' });
    this.validator.attach('country', 'required', { prettyName: 'Country' });
    this.validator.attach('contact_phone', 'required|max:32', { prettyName: 'Billing Contact Phone' });
    this.validator.attach('contact_email', 'required|email', { prettyName: 'Billing E-mail' });

    this.$set(this, 'formErrors', this.validator.errorBag);
  },
  methods: {
    onSubmit: function() {
       // hide alert
      this.showAlert = false;

      const validateFields = {
        first_name: this.newBillingInformation.first_name,
        last_name: this.newBillingInformation.last_name,
        address1: this.newBillingInformation.address1,
        city: this.newBillingInformation.city,
        state: this.newBillingInformation.state,
        zipcode: this.newBillingInformation.zipcode,
        country: this.newBillingInformation.country,
        contact_phone: this.newBillingInformation.contact_phone,
        contact_email: this.newBillingInformation.contact_email,
      };

      if (this.isRequiredTaxIDField) {
        this.validator.attach('tax_id', 'required|digits:13', { prettyName: 'Tax ID' });
        validateFields.tax_id = this.newBillingInformation.tax_id;
      } else {
        this.validator.detach('tax_id');
      }

      this.validator.validateAll(validateFields)
      .then((success) => {
        if (!success) {
          return;
        }
        this.isSubmiting = true;

        return axios.post(`/api/teams/${this.team.namespace}/billing/info`, this.newBillingInformation);
      })
      .then((response) => {
        this.isSubmiting = false;
        this.errorResponse = null;

        this.newBillingInformation = response.data;

        this.$emit('save', this.newBillingInformation);
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 422) {
            this.errorResponse = this.$t('billing.information.response.failed');
            this.formErrors.addAll(error.response.data);
          } else {
            this.errorResponse = this.$t('billing.information.response.defaultFailed');
          }

          this.showAlert = true;
        }
        this.isSubmiting = false;
      });
    },
    refreshBillingInformation: function() {
      this.clearFormErrors();

      this.newBillingInformation = Object.assign({}, this.billingInformation);
    },
    onCancelButtonClick: function() {
      this.$emit('cancel');
    },
    clearForm() {
      this.newBillingInformation.first_name = null;
      this.newBillingInformation.last_name = null;
      this.newBillingInformation.company_name = null;
      this.newBillingInformation.tax_id = null;
      this.newBillingInformation.address1 = null;
      this.newBillingInformation.address2 = null;
      this.newBillingInformation.city = null;
      this.newBillingInformation.state = null;
      this.newBillingInformation.zipcode = null;
      this.newBillingInformation.country = 'TH';
      this.newBillingInformation.contact_phone = null;
      this.newBillingInformation.contact_email = null;

      this.clearFormErrors();
    },
    clearFormErrors() {
      this.formErrors.clear();
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// BillingInformationForm.vue?351cbe92